<template>
  <LineChartGenerator
    v-if="chartData"
    :chart-options="getChartOptions()"
    :chart-data="chartData"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import annotationPlugin from "chartjs-plugin-annotation";
import {
  Chart,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  TimeScale,
} from "chart.js";

const warningPlugin = {
  id: "warningMessage",
  afterDraw: (chart) => {
    if (chart.config.options.showProductionObjectiveWarning) {
      const ctx = chart.ctx;
      // const chartArea = chart.chartArea;
      const chartWidth = chart.width;
      // const chartHeight = chart.height;

      // Warning text and icon (use local path here)
      const warningMessage = i18n.t("dashboard.containsProductInCalibrationWarning");
      const iconUrl = "/warning.svg";

      // Position the message and icon
      const xPadding = 10;
      const yPadding = 20;
      const iconSize = 26;

      // Draw the icon
      const img = new Image();
      img.src = iconUrl;
      img.onload = () => {
        // Position the icon on the top-left corner
        // const iconX = chartWidth - padding;
        // const iconY = padding;

        // Draw the warning message text to the right of the icon
        ctx.font = '14px Arial';
        ctx.fillStyle = 'hsla(0, 0%, 100%, 0.7)';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle'; // Align text vertically with the center of the icon
        const textX = chartWidth - xPadding - ctx.measureText(warningMessage).width;
        const textY = yPadding;
        ctx.fillText(warningMessage, textX, textY);

        const iconX = textX - xPadding / 2 - iconSize;
        const iconY = 5;
        ctx.drawImage(img, iconX, iconY, iconSize, iconSize);
      };
    }
  },
};

Chart.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  annotationPlugin,
  TimeScale,
  warningPlugin,
);

import "chartjs-adapter-luxon";
import i18n from "@/i18n";
export default {
  name: "WxChartLineGraph",
  components: {
    LineChartGenerator,
  },
  props: {
    width: {
      type: Number,
      default: 200,
    },
    height: {
      type: Number,
      default: 450,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [
        {
          id: "transparant_background_plugin",
          beforeDraw: (chart) => {
            const { ctx } = chart;
            ctx.save();
            ctx.globalCompositeOperation = "destination-over";
            ctx.fillStyle = "transparent";
            ctx.fillRect(0, 0, chart.width, chart.height);
            ctx.restore();
          },
        },
      ],
    },
    chartData: {
      type: Object,
      default: () => ({
        datasets: [],
        labels: []
      }),
    },
    chartOptions: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getChartOptions() {
      return { ...this.chartOptions };
    },
  },
};
</script>
<style lang="scss" scoped></style>